module.exports = __webpack_public_path__ + "static/media/BlueArrowDown.09e4d4f4.svg";